// Data access for GET /admin/activity (the unified audit_log behind the
// admin Activity page).
import type { AuditActor, AuditLogEntry } from "@cms/types";
import type { ApiClient } from "./api";

export interface ActivityFilters {
  /** Exact-match filters; "" means "all". */
  category: string;
  actor: string;
  tenant: string;
}

export const NO_ACTIVITY_FILTERS: ActivityFilters = { category: "", actor: "", tenant: "" };

export interface ActivityPageResult {
  entries: AuditLogEntry[];
  /** Facets: every distinct value present in the log, for the filter menus. */
  categories: string[];
  actors: AuditActor[];
  tenants: string[];
  total: number;
}

/** List-controls query string plus the Activity page's exact-match filters. */
export function activityQueryString(base: string, filters: ActivityFilters): string {
  const params = new URLSearchParams(base);
  if (filters.category) params.set("category", filters.category);
  if (filters.actor) params.set("actor", filters.actor);
  if (filters.tenant) params.set("tenant", filters.tenant);
  return params.toString();
}

export async function fetchActivityPage(api: ApiClient, query: string): Promise<ActivityPageResult> {
  const data = await api.request<Partial<ActivityPageResult>>(
    `/admin/activity${query ? `?${query}` : ""}`
  );
  return {
    entries: data.entries ?? [],
    categories: data.categories ?? [],
    actors: data.actors ?? [],
    tenants: data.tenants ?? [],
    total: data.total ?? 0
  };
}

/** "act_as" -> "act as", for badges and menu labels. */
export function formatCategory(category: string): string {
  return category.replaceAll("_", " ");
}

/** Pretty-print a detail_json payload; unparseable values render raw. */
export function formatDetail(detailJson: string): string {
  try {
    return JSON.stringify(JSON.parse(detailJson), null, 2);
  } catch {
    return detailJson;
  }
}
